<!-- desktop template -->
<div id="filtersFormComponents" *appIsDesktop>
  <div id="searchContainerDesktop" class="search-container-desktop">
    <div id="filtersContainer" class="filters-container">
      <ds-textfield class="full-flex no-subscript" id="searchField" (click)="openAdvancedFilteringDialog()" [control]="searchForm.controls.displayedSearchValue"
        end_adornment_type="icon" end_adornment_value_icon="search" placeholder="Search">
      </ds-textfield>
      @if (currentSearchText || clearFiltersNeeded) {
        <div id="filtersContainerText" class="filters-container-text">
          <ds-divider id="verticalDivider1" class="vertical-divider" [vertical]="true"></ds-divider>
          <div id="showResultsContainer" class="text-align">
            <span id="showResults">{{ appStrings.accounts_showingResultsFor }}
              @if (currentSearchText) {
                <span>"{{currentSearchText}}"</span>
              }
              @if (clearFiltersNeeded && !currentSearchText) {
                <span>
                  {{ appStrings.quotesYourFilters }}
                </span>
              }
            </span>
          </div>
          <ds-divider id="verticalDivider2" class="vertical-divider" [vertical]="true"></ds-divider>
          <div id="clearFiltersContainer" class="text-align">
            <span id="clearAllFilters" class="clickable" (click)="clearFilters()">
              {{ appStrings.accounts_clearFilters }}
            </span>
          </div>
        </div>
      }
    </div>
    @if (!isOnAccountsPage && !importQuoteActive) {
      <ds-button size="medium" variant="label-only" label="{{appStrings.button_newQuote}}" (click)="handleNewQuote()" id="newQuoteButton">
      </ds-button>
    }
  </div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  <ds-paper elevation="elevation_none" [borderRadius]="isOnAccountsPage ? 'radius_S' : 'radius_XS'" outline="outlined"
    insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S"
    insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
    <div id="mobileSearchContainer" class="search-container">
      <ds-textfield #searchFieldMobile class="fill-width no-subscript" id="searchFieldMobile"
        (click)="openAdvancedFilteringDialog()" [control]="searchForm.controls.displayedSearchValue"
        end_adornment_type="icon" end_adornment_value_icon="search" placeholder="Search">
      </ds-textfield>
      @if (!isOnAccountsPage) {
        <ds-button id="mobileAddButton" class="add-button" shape="square" size="medium"
          type="primary" variant="icon-only" icon="add" label="Primary Button" iconPosition="left"
          iconStyle="material-icons" (click)="handleNewQuote()">
        </ds-button>
      }
    </div>
    @if (isOnAccountsPage) {
      <div>
        <ng-container *ngTemplateOutlet="mobileShowingTextTemplate"></ng-container>
      </div>
    }
  </ds-paper>

  @if (!isOnAccountsPage) {
    <div id="mobileTitle" class="title">
      <typography variant="mat-headline-4" weight="bold">{{ appStrings.menu_Quotes }}</typography>
    </div>
  }

  @if (!isOnAccountsPage) {
    <ng-content></ng-content>
  }

  @if (!isOnAccountsPage) {
    <div>
      <ng-container *ngTemplateOutlet="mobileShowingTextTemplate"></ng-container>
    </div>
  }
</div>

<ng-template #mobileShowingTextTemplate>
  @if (currentSearchText || clearFiltersNeeded) {
    <div>
      <div id="mobileShowingText" class="showing-text">
        <span id="showResultsMobile" class="filters-text">{{ appStrings.accounts_showingResultsFor }}
          @if (currentSearchText) {
            <span>"{{currentSearchText}}".</span>
          }
          @if (clearFiltersNeeded && !currentSearchText) {
            <span>
              {{ appStrings.quotesYourFilters }}
            </span>
            }&nbsp;
          </span>
          @if (!isOnAccountsPage) {
            <span id="clearAllFiltersMobile" class="clickable clear-filters" (click)="clearFilters()">
              {{ appStrings.accounts_clearFilters }}
            </span>
          }
        </div>
        @if (isOnAccountsPage) {
          <span id="clearAllFiltersMobile" class="clickable clear-filters" (click)="clearFilters()">
            {{ appStrings.accounts_clearFilters }}
          </span>
        }
      </div>
    }
  </ng-template>